// Accordeons
function filterAccordeons() {
  const filters = document.querySelectorAll('.sauce_catalogue_filters_wrapper');

  // Etat par défaut uniquement au chargement
  filters.forEach(wrapper => {
    if (window.innerWidth > 768) {
      wrapper.classList.add('is-open');
    }
  });


  // Accordéon
  document.querySelectorAll('.sauce_catalogue_filters_title_button').forEach(button => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.sauce_catalogue_filters_wrapper');
      wrapper.classList.toggle('is-open');
    });
  });
}

function getRequiredFiltersMissing() {
  const required = ['ethniques', 'sectors'];
  return required.filter(tax =>
    document.querySelector(`.filter-pill.is-active[data-tax="${tax}"]`) === null
  );
}

function toggleFilterButtonsActions() {
  const missing = getRequiredFiltersMissing();
  const sendBtn = document.getElementById('js-send-filters');
  const resetBtn = document.getElementById('js-reset-filters');
  const hasAnyActive = document.querySelector('.filter-pill.is-active') !== null;
  const { hasSelection } = getSelectionState();

  sendBtn?.classList.toggle('is-incomplete', missing.length > 0 && !hasSelection);
  resetBtn?.classList.toggle('is-disabled', !hasAnyActive);

  if (missing.length === 0 || hasSelection) {
    hideFilterValidationMsg();
  }
}

function filterButtonSelectAllProduct() {
    const button = document.querySelector('.sauce_catalogue_select_all-js');
    if (!button) return;
    const selectText = button.querySelector('.select_all_text');
    const deselectText = button.querySelector('.deselect_all_text');
    deselectText.style.display = 'none';
    button.addEventListener('click', () => {
        const products = document.querySelectorAll('.sauce_component');
        const checkboxes = [];
        products.forEach(product => {
            if (product.style.display !== 'none') {
                const checkbox = product.querySelector('.sauce_component_select');
                if (checkbox) {
                    checkboxes.push(checkbox);
                }
            }
        });
        const isSelected = button.dataset.selected === 'true';
        checkboxes.forEach(checkbox => {
            checkbox.checked = !isSelected;
        });
        button.dataset.selected = !isSelected;
        if (!isSelected) {
            selectText.style.display = 'none';
            deselectText.style.display = 'inline';
        } else {
            selectText.style.display = 'inline';
            deselectText.style.display = 'none';
        }
        updateSelectionUI();
    });
}

function hideFilterValidationMsg() {
  const msg = document.getElementById('js-filter-validation-msg');
  if (!msg) return;
  msg.hidden = true;
}

function showFilterValidationMsg(missingTaxes) {
  const msg = document.getElementById('js-filter-validation-msg');
  if (!msg) return;
  msg.querySelectorAll('li[data-required]').forEach(li => {
    li.hidden = !missingTaxes.includes(li.dataset.required);
  });
  msg.hidden = false;
}

// Begin - Popup filtres (modale)
function getFilterPopup() {
  return document.getElementById('filter-wrapper-form');
}

function openFilterPopup() {
  const popup = getFilterPopup();
  if (!popup) return;
  popup.classList.remove('d-none');
  popup.classList.add('block');
  document.body.classList.add('filter-popup-open');
  popup.scrollTop = 0;
  // On évite le honeypot anti-spam GF (.gform_validation_container)
  popup.querySelector('form .gfield:not(.gform_validation_container) input:not([type="hidden"]), form textarea')?.focus();
}

function closeFilterPopup() {
  const popup = getFilterPopup();
  if (!popup) return;
  popup.classList.add('d-none');
  popup.classList.remove('block');
  document.body.classList.remove('filter-popup-open');
}

function initFilterPopup() {
  const popup = getFilterPopup();
  if (!popup) return;

  // Sort la modale des stacking contexts (sections animées avec transform)
  // pour qu'elle passe au-dessus du header
  document.body.appendChild(popup);

  popup.addEventListener('click', (e) => {
    if (e.target === popup || e.target.closest('.sauce_catalogue_filters_form_button_close')) {
      closeFilterPopup();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !popup.classList.contains('d-none')) {
      closeFilterPopup();
    }
  });

  bindFilterPopupForm(popup);
}

// Soumission AJAX : la réponse GF (erreurs ou confirmation) est réinjectée
// dans la modale au lieu de laisser le navigateur ouvrir la réponse brute
function bindFilterPopupForm(popup) {
  const form = popup.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    popup.classList.add('is-submitting');

    fetch(form.getAttribute('action') || window.location.href, {
      method: 'POST',
      body: new FormData(form),
    })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.gform_wrapper, [id^="gform_confirmation_wrapper"]');
        const current = popup.querySelector('.gform_wrapper, [id^="gform_confirmation_wrapper"]');
        if (fresh && current) {
          current.replaceWith(fresh);
          bindFilterPopupForm(popup); // nouveau <form> → on rebranche le submit
        } else if (submitBtn) {
          submitBtn.disabled = false;
        }
        popup.scrollTop = 0;
      })
      .catch(() => {
        if (submitBtn) submitBtn.disabled = false;
      })
      .finally(() => {
        popup.classList.remove('is-submitting');
      });
  });
}
// End - Popup filtres (modale)

// Begin - Recap des filtres/sauces au-dessus du formulaire (même contenu que celui envoyé par email)
const RECAP_TAX_ORDER = ['sectors', 'ethniques', 'gammes', 'types', 'usages', 'conditionnement', 'intensity'];

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function getTaxLabel(tax) {
  const title = document.querySelector(`.sauce_catalogue_filters_wrapper_${tax} .sauce_catalogue_filters_title`);
  return title ? title.textContent.trim() : tax;
}
// End - Recap des filtres/sauces

// Begin - For change text button for the devis
function getSelectionState() {
    const selected = document.querySelectorAll('.sauce_component_select:checked');

    return {
        hasSelection: selected.length > 0,
        count: selected.length
    };
}

function updateSelectionUI() {
    const state = getSelectionState();

    const selectAllBtn = document.querySelector('.sauce_catalogue_select_all');
    const sendBtn = document.getElementById('send-filters-js');

    selectAllBtn?.classList.toggle('has-selection', state.hasSelection);

    sendBtn?.classList.toggle('is-disabled', !state.hasSelection);

    // 👇 classe globale état sélection
    document.body.classList.toggle('has-product-selection', state.hasSelection);

    console.log('selection:', state.count);
}

document.addEventListener('change', (e) => {
    if (e.target.classList.contains('sauce_component_select')) {
        updateSelectionUI();
        toggleFilterButtonsActions();
    }
});

// End - For change text button for the devis

document.addEventListener('DOMContentLoaded', () => {
  filterAccordeons();
  filterIntensity();
  filterButtonSelectAllProduct();
  updateSelectionUI();
  initFilterPopup();

  function filterIntensity() {
    const intensityPills = document.querySelectorAll('[data-tax="intensity"][data-level]');

    intensityPills.forEach(btn => {
      btn.addEventListener('click', () => {

        const level = Number(btn.dataset.level);

        const alreadyActive = btn.classList.contains('is-active')
          && level === getCurrentLevel();

        const newLevel = alreadyActive ? 0 : level;

        intensityPills.forEach(item => {
          const itemLevel = Number(item.dataset.level);
          item.classList.toggle('is-active', itemLevel <= newLevel);
        });

        setCurrentLevel(newLevel);

        updateActiveFilters();
        filterProducts();
        toggleFilterButtonsActions();

        if (newLevel > 0) {
          document.dispatchEvent(new CustomEvent('sauce:need-all-products'));
        }
      });
    });
  }

  const filterContainer = document.getElementById('js-filters');
  const productContainer = document.getElementById('js-products');
  const sendFiltersBtn = document.getElementById('js-send-filters');
  const resetBtn = document.getElementById('js-reset-filters');

  if (!filterContainer || !productContainer) return;

  const pills = Array.from(
    filterContainer.querySelectorAll('.filter-pill:not([data-tax="intensity"])')
  );
  let products = Array.from(productContainer.querySelectorAll('.product-card'));
  const ethniqueDescriptionBox = document.getElementById('js-ethniques-description');
  const conditionnementDescriptionBox = document.getElementById('js-conditionnement-description');

  const activeFilters = {}; // { gamme: ['classiques'], type: ['mayonnaises'], ... }
  const ethniqueClickOrder = []; // dernier élément = dernier bouton ethnique cliqué

  function updateEthniqueDescription(clickedPill) {
    if (!ethniqueDescriptionBox) return;

    if (clickedPill && clickedPill.dataset.tax === 'ethniques') {
      const existingIndex = ethniqueClickOrder.indexOf(clickedPill);
      if (existingIndex !== -1) ethniqueClickOrder.splice(existingIndex, 1);
      if (clickedPill.classList.contains('is-active')) ethniqueClickOrder.push(clickedPill);
    }

    while (ethniqueClickOrder.length && !ethniqueClickOrder[ethniqueClickOrder.length - 1].classList.contains('is-active')) {
      ethniqueClickOrder.pop();
    }

    const activePill = ethniqueClickOrder[ethniqueClickOrder.length - 1];
    const description = activePill?.dataset.description || '';
    ethniqueDescriptionBox.textContent = description;
    ethniqueDescriptionBox.hidden = description === '';
  }

  function updateConditionnementDescription() {
    if (!conditionnementDescriptionBox) return;

    const selected = activeFilters['conditionnement'] || [];
    const spans = conditionnementDescriptionBox.querySelectorAll('[data-variant]');

    if (selected.length === 0) {
      conditionnementDescriptionBox.hidden = true;
      spans.forEach(span => { span.hidden = true; });
      return;
    }

    const selectedPills = pills.filter(pill =>
      pill.dataset.tax === 'conditionnement' && selected.includes(pill.dataset.term)
    );
    const hasGlass = selectedPills.some(pill => pill.dataset.material === 'glass');
    const hasPlastic = selectedPills.some(pill => pill.dataset.material !== 'glass');

    const variant = hasGlass && hasPlastic ? 'mixed' : hasGlass ? 'glass' : 'plastic';

    conditionnementDescriptionBox.hidden = false;
    spans.forEach(span => { span.hidden = span.dataset.variant !== variant; });
  }

  function refreshProducts() {
    products = Array.from(productContainer.querySelectorAll('.product-card'));
  }

  function renderFiltersRecap(activeFilters, selectedSauces) {
    const recap = document.getElementById('js-filters-recap');
    if (!recap) return;

    const filterItems = RECAP_TAX_ORDER
      .filter(tax => tax !== 'intensity' && (activeFilters[tax] || []).length > 0)
      .map(tax => {
        const labels = activeFilters[tax].map(term => {
          const pill = pills.find(p => p.dataset.tax === tax && p.dataset.term === term);
          return pill?.querySelector('span')?.textContent.trim() || term;
        });
        return `<li><span class="sauce_catalogue_filters_form_recap_tax">${escapeHtml(getTaxLabel(tax))}</span> : ${escapeHtml(labels.join(', '))}</li>`;
      });

    if (currentIntensityLevel > 0) {
      filterItems.push(`<li><span class="sauce_catalogue_filters_form_recap_tax">${escapeHtml(getTaxLabel('intensity'))}</span> : ${currentIntensityLevel}</li>`);
    }

    let html = '';

    if (filterItems.length > 0) {
      html += `<div class="sauce_catalogue_filters_form_recap_block">
        <p class="sauce_catalogue_filters_form_recap_title">${escapeHtml(recap.dataset.filtersTitle || '')}</p>
        <ul>${filterItems.join('')}</ul>
      </div>`;
    }

    if (selectedSauces.length > 0) {
      html += `<div class="sauce_catalogue_filters_form_recap_block">
        <p class="sauce_catalogue_filters_form_recap_title">${escapeHtml(recap.dataset.saucesTitle || '')}</p>
        <ul>${selectedSauces.map(sauce => `<li>${escapeHtml(sauce)}</li>`).join('')}</ul>
      </div>`;
    }

    recap.innerHTML = html;
    recap.hidden = html === '';
  }

  function updateActiveFilters() {
    // reset
    Object.keys(activeFilters).forEach(key => delete activeFilters[key]);

    pills
      .filter(pill => pill.classList.contains('is-active'))
      .forEach(pill => {
        const tax = pill.dataset.tax;
        const term = pill.dataset.term;
        if (!activeFilters[tax]) activeFilters[tax] = [];
        activeFilters[tax].push(term);
      });
  }

  /*function filterProducts() {
    updateActiveFilters();

    products.forEach(product => {
      const productTerms = (product.dataset.terms || '').split(' ').filter(Boolean);

      // si aucun filtre actif, tout afficher
      if (Object.keys(activeFilters).length === 0) {
        product.style.display = '';
        return;
      }

      // chaque tax doit matcher au moins un terme choisi
      let visible = true;

      Object.keys(activeFilters).forEach(tax => {
        const termsForTax = activeFilters[tax];
        const hasMatch = termsForTax.some(term => productTerms.includes(term));
        if (!hasMatch) visible = false;
      });

      product.style.display = visible ? '' : 'none';
    });
  }*/

  function filterProducts() {
      updateActiveFilters();
      products.forEach(product => {
          let visible = true;
          Object.keys(activeFilters).forEach(tax => {
              const values = activeFilters[tax];
              const productValues = (product.dataset[tax] || '').split(' ').filter(Boolean);
              const match = values.some(v => productValues.includes(v));
              if (!match) visible = false;
          });

          // intesity
          if (currentIntensityLevel > 0) {
              const productIntensity = Number(product.dataset.intensity || 0);
              if (productIntensity !== currentIntensityLevel) {
                  visible = false;
              }
          }
          product.style.display = visible ? '' : 'none';
      });
  }

  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      pill.classList.toggle('is-active');
      filterProducts();
      toggleFilterButtonsActions();
      updateEthniqueDescription(pill);
      updateConditionnementDescription();

      if (pill.classList.contains('is-active')) {
        document.dispatchEvent(new CustomEvent('sauce:need-all-products'));
      }
    });
  });

  resetBtn?.addEventListener('click', () => {
    pills.forEach(p => p.classList.remove('is-active'));
    setCurrentLevel(0);
    document.querySelectorAll('[data-tax="intensity"][data-level]').forEach(item => item.classList.remove('is-active'));
    hideFilterValidationMsg();
    filterProducts();
    toggleFilterButtonsActions();
    updateSelectionUI();
    updateEthniqueDescription();
    updateConditionnementDescription();
  });

  // Envoi vers Gravity Forms
  sendFiltersBtn?.addEventListener('click', () => {
    const missing = getRequiredFiltersMissing();
    const { hasSelection } = getSelectionState();
    if (missing.length > 0 && !hasSelection) {
      showFilterValidationMsg(missing);
      return;
    }

    hideFilterValidationMsg();
    updateActiveFilters();

    // Sauces cochées par le client, ajoutées au payload sous la clé "sauces"
    const selectedSauces = Array.from(document.querySelectorAll('.sauce_component_select:checked'))
      .map(checkbox => checkbox.value);
    const payloadData = { ...activeFilters };
    if (selectedSauces.length > 0) {
      payloadData.sauces = selectedSauces;
    }

    // On sérialise les filtres en JSON dans le champ caché "Data Json" du form GF 6
    const payload = JSON.stringify(payloadData);
    const gfField = document.querySelector('#input_6_21, [data-gf-filters-field]');
    if (gfField) {
      gfField.value = payload;
    }

    renderFiltersRecap(activeFilters, selectedSauces);

    openFilterPopup();

    // 2) soit tu passes par des query params pour pré-remplir GF sur une autre page
    // const url = new URL('/contact-filtres/', window.location.origin);
    // url.searchParams.set('filters', payload);
    // window.location.href = url.toString();
  });

  // Sauces ajoutées par le bouton "Voir plus" (app.js) : on les intègre
  // au filtrage courant au lieu de les laisser toujours visibles.
  document.addEventListener('sauce:products-loaded', () => {
    refreshProducts();
    filterProducts();
  });
});

// Intensity tag
let currentIntensityLevel = 0;

function getCurrentLevel() {
  return currentIntensityLevel;
}

function setCurrentLevel(val) {
  currentIntensityLevel = val;
}